/** Email for ordering devices and chips. */
export const ORDER_EMAIL = 'rescues@tryfi.com';

/** Email for Nano microchip orders. */
export const NANO_ORDER_EMAIL = 'nanosupport@tryfi.com';

/** Email for general rescue support inquiries. */
export const SUPPORT_EMAIL = 'rescuesupport@tryfi.com';
